import { ElementUtils } from "../../UI.ElementarControls/Helpers/ElementUtils";

export class EventHelper {
    /**
     * Zastaví propagaci události, ale současně notifikuje o tomto zastavení (vyvolává událost "<název události>Cancelled")
     * @param e Událost, ktará má být zastavena
     */
    public static stopPropagation(e: Event): void {
        e.stopPropagation();
        ElementUtils.callEvent(EventHelper._getEventSource(e), e.type + "Cancelled", EventHelper._getEventDetails(e), true);
    }

    /**
     * Zastaví propagaci události a přeruší i vyvolání dalších listenerů, které jsou navázané na zdrojovém elementu,
     * ale současně notifikuje o tomto zastavení (vyvolává událost "<název události>Cancelled")
     * @param e Událost, ktará má být zastavena
     */
    public static stopImmediatePropagation(e: Event): void {
        e.stopImmediatePropagation();
        ElementUtils.callEvent(EventHelper._getEventSource(e), e.type + "Cancelled", EventHelper._getEventDetails(e), true);
    }

    /**
     * Zjistí nejvhodnější zdrojový element události
     * @param e Událost, pro kterou se hledá
     */
    private static _getEventSource(e: Event): HTMLElement {
        return e.currentTarget instanceof HTMLElement ? e.currentTarget as HTMLElement : document.body;
    }

    /**
     * Vytvoří informace pro detail nové rušící události
     * @param e Událost, která je rušená
     */
    private static _getEventDetails(e: Event): {} {
        if (!(e instanceof MouseEvent))
            return { sender: EventHelper._getEventSource(e) };

        const mouseEvent = e as MouseEvent;
        return {
            sender: EventHelper._getEventSource(e),
            x: mouseEvent.pageX,
            y: mouseEvent.pageY,
        };
    }
}
